import React from "react";
import {
  formatOrganizedTourPublicOfferIlsWithPrimary,
  resolveOrganizedTourPublicOfferPrimaryFx,
} from "../../../modules/organizedTours/utils/resolveOrganizedTourPublicOfferFinalPriceIls";
import { useAppContext } from "../../../contexts/AppContext";

/**
 * בלוק «חדרי ההצעה» להצעה הציבורית — רק אם יש שורות חדרים ב-snapshot.
 */
export default function OrganizedTourPublicOfferRoomsBlock({
  rooms = null,
  vm = null,
  titleAfterBlock = false,
}) {
  const { currencyRate } = useAppContext();
  const rows = Array.isArray(rooms) ? rooms.filter(Boolean) : [];
  if (!rows.length) return null;

  return (
    <section className="organized-tour-public-offer__rooms-section" aria-label="חדרי ההצעה">
      <h3
        className={`organized-tour-public-offer__panel-section-title organized-tour-public-offer__rooms-section-title${
          titleAfterBlock ? " organized-tour-public-offer__panel-section-title--after-block" : ""
        }`.trim()}
      >
        חדרי ההצעה
      </h3>
      <ul className="organized-tour-public-offer__rooms-list">
        {rows.map((row, idx) => {
          const key = `${row.slot_index ?? idx}-${row.room_set ?? "room"}`;
          const ils =
            row.price_ils != null && Number.isFinite(Number(row.price_ils))
              ? Math.round(Number(row.price_ils))
              : null;
          const fx = resolveOrganizedTourPublicOfferPrimaryFx(
            vm,
            ils,
            currencyRate,
            row
          );
          const price =
            ils != null
              ? formatOrganizedTourPublicOfferIlsWithPrimary(
                  `₪${ils.toLocaleString("he-IL")}`,
                  fx.display
                )
              : null;
          const metaParts = [];
          if (row.room_set) metaParts.push(String(row.room_set));
          if (row.occupancy_label_he) metaParts.push(row.occupancy_label_he);
          if (row.room_type) metaParts.push(row.room_type);
          return (
            <li key={key} className="organized-tour-public-offer__room-row">
              <div className="organized-tour-public-offer__room-row-main">
                <span className="organized-tour-public-offer__room-slot">{row.slot_label_he || "חדר"}</span>
                <span className="organized-tour-public-offer__room-composition">
                  {row.composition_label_he || "חדר"}
                </span>
                {metaParts.length ? (
                  <span className="organized-tour-public-offer__room-meta">{metaParts.join(" · ")}</span>
                ) : null}
              </div>
              {price ? (
                <span className="organized-tour-public-offer__room-price">{price}</span>
              ) : (
                <span className="organized-tour-public-offer__room-price organized-tour-public-offer__room-price--empty">—</span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
